import React from "react";
import { Redirect, Link } from "react-router-dom";
import {
  ListGroupItem,
  Row,
  Col,
  Input,
  Card,
  CardImg,
  CardText,
  CardSubtitle,
  CardTitle,
  Button,
  CardBody,
  Container
} from "reactstrap";
import Marquee from "react-fast-marquee";

import { ReactComponent as SelectedLogo } from "../selected.svg";

export default class cardItemw extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      error: "",
      usingThumbNails: true,
      selected: this.props.selected,
      singleWordMax : 5,
      totalTextMax : 30
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.windowResized = this.windowResized.bind(this);

    this.measuringDivRef = React.createRef();
    this.measuringDivHeightRef = React.createRef();
    this.colRef = React.createRef();

  }

  componentDidMount() {
    window.addEventListener('resize', this.windowResized);
    this.windowResized();
  }

  componentWillUnmount() {
    // you need to unbind the same listener that was binded.
    window.removeEventListener('resize', this.windowResized, false);
}

  handleInputChange(e) {
    this.props.scrollDrop();
    let status = !this.state.selected;

    this.setState({
      selected: status,
    });

    this.props.itemSelector(this.props.item, status);


  }


  componentDidUpdate(prevProps, prevState) {
    if (prevProps !== this.props) {
      this.setState({
        selected: this.props.selected,
      });
    }
  }

  windowResized(e){
    this.setState({
      singleWordMax : Math.max((window.innerWidth - 375) / 40,9),
      totalTextMax : Math.max(8, window.innerWidth / 60)
    })
  }

  render() {
    let tickerText = (
      <Marquee gradient={false}>
        <h5 style={{fontSize:"1.2em", width:"100%", marginRight:"20px",fontWeight: "bold"}}>{this.props.item.name}</h5>
      </Marquee>
    );

    let normalText = (
      <h5 style={{fontSize:"1.2em", width:"100%", overflowWrap: "normal", fontWeight: "bold"}}>{this.props.item.name}</h5>
    )

    let toDisplay = normalText;

    if(this.measuringDivRef.current){
      let col = this.measuringDivRef.current.parentElement;
      let text = this.measuringDivRef.current.firstChild;
      let heightText = this.measuringDivHeightRef.current.firstChild;

      if(text.clientHeight > col.clientHeight){
        toDisplay = tickerText;
      }else{
        if(heightText.clientWidth > text.clientWidth){
          toDisplay = tickerText;
        }
      }

      toDisplay = normalText;
      //console.log(this.props.item.name, text.clientHeight, col.clientHeight, text.clientWidth, heightText.clientWidth);
    }

    return (
      <React.Fragment>
        <Col sm>
        <Card
          style={{
            width:"250px",
            height:"250px",
            borderRadius: "23px",
            marginBottom: "20px",
            zIndex: "10",
            display:"flex",
            alignItems :"stretch",
            borderColor: this.state.selected ? "#ffed00" : "transparent",
            borderWidth: "6px",
            boxSizing : "border-box",
            paddingLeft : "-30px"
          }}
        >

            <Container fluid className="p-0" style={{height:"100%"}} onClick={this.handleInputChange}>
              <Row className="p-0" style={{height:"65%"}}>
                <Col className="h-100 p-0">
                  <Container className="p-0" style={{margin: "0px", height:"100%"}}>
                    <img className="itemImage" style={{width:"auto", height:"100%", objectFit:"contain"}} src={this.props.item.thumbnail} />
                  </Container>
                </Col>
              </Row>
              <Row className="px-3 py-0" style={{height:"35%"}}>
                <Col className="h-100 p-0" style={{color:"#0061ae", overflow:"hidden",display:"flex", justifyContent:"center", fontWeight: "bolder"}}>
                  <div id="measuringDiv" ref={this.measuringDivRef} style={{ position: "absolute",
                                                                    visibility: "hidden",
                                                                    width: "100%",
                                                                    }}>
                    {normalText}
                  </div>
                  <div id="measuringDivHeight" ref={this.measuringDivHeightRef} style={{ position: "absolute",
                                                                                        visibility: "hidden",
                                                                                        height: "30%",
                                                                                        width:"auto",
                                                                                        }}>
                    {normalText}
                  </div>
                  <div style={{ position: "absolute",
                                width: "100%",
                                wordBreak: "keep-all",
                                visibility: "visible" }}>
                  {toDisplay}
                  </div>
                </Col>
              </Row>
              </Container>
              {this.state.selected == true && (
                <div
                  style={{
                    position:"absolute",
                    top :"10px",
                    right : "0px",
                    zIndex:"11",
                    marginTop:"0px"
                  }}
                >
                  <SelectedLogo style={{marginTop:"0px", marginRight:"0px", height:"2.5em"}} />
                </div>
              )}

          </Card>
        </Col>
      </React.Fragment>
    );
  }
}
